export default __webpack_public_path__ + "static/media/newmouse.aba7f69c.svg";